import React from 'react';
import styled from 'styled-components';

import MaterialSymbol from 'components/basic/icons/MaterialSymbol';

export const EXPAND_COLUMN_WIDTH = '25px';

const ArrowRightStyled = styled(MaterialSymbol)`
  vertical-align: middle;
  margin-right: -7px;
`;

export const ExpandColumnIcon = () => {
  return <ArrowRightStyled icon="arrow_right" rounded />;
};
